import Service from '../service.js';
import Pagination from '@/components/pagination/index.vue';
import { errorMessage } from '@/utils/message.js';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      total: 0,
      tableList: [],
      searchForm: {
        pageNum: 1,
        pageSize: 5
      }
    };
  },
  created() {
    this.getStockList();
  },
  methods: {
    getStockList(page){
      if (page) {
        this.searchForm.pageNum = page.pageNo;
        this.searchForm.pageSize = page.pageSize;
      } else {
        this.searchForm.pageNum = 1;
        this.searchForm.pageSize = 5;
      }
      Service.getStockList().then(res => {
        if (res && res.code === '0') {
          this.total = res.data.total;
          this.tableList = res.data;
        } else {
          errorMessage(res && res.reason);
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    }
  }
};
